import { FollowTargetTypeEnum } from '../../..';
//TODO: Unused?

export class FollowTargetsDto {
  targetId: string;
  targetType: FollowTargetTypeEnum;
}
